import EmergencyMessageConnector from './emergencyMessage.props';
import EmergencyMessageComponent from './emergencyMessage.component';

export default EmergencyMessageConnector(EmergencyMessageComponent);
